export default "__VITE_ASSET__Dey2x_58__"